import { render, staticRenderFns } from "./OfferType.vue?vue&type=template&id=2279a22e"
import script from "./OfferType.vue?vue&type=script&lang=js"
export * from "./OfferType.vue?vue&type=script&lang=js"
import style0 from "./OfferType.vue?vue&type=style&index=0&id=2279a22e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports